import { render, staticRenderFns } from "./full-source.vue?vue&type=template&id=2d1df2c6&scoped=true&"
import script from "./full-source.vue?vue&type=script&lang=js&"
export * from "./full-source.vue?vue&type=script&lang=js&"
import style0 from "./full-source.vue?vue&type=style&index=0&id=2d1df2c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1df2c6",
  null
  
)

export default component.exports